/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type personalizedFiltersHelpers_shippingFilters$ref: FragmentReference;
export type personalizedFiltersHelpers_shippingFilters = $ReadOnlyArray<{|
  +totalCount: ?number,
  +$refType: personalizedFiltersHelpers_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "personalizedFiltersHelpers_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4ce009729efa2bb5edc0685db84567ae';
module.exports = node;
